import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules example : When your routing table is too long, you can split it into small modules **/
// import customRouter from './modules/customMenu'

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

export const constantRouterMap = [
  {
     path: '/redirect',
     component: Layout,
     hidden: true,
     children: [
       {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
     ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/index'),
        name: 'Home',
        meta: { title: 'Dashboard', icon: 'account_balance', iconType: 'material', affix: true }
      }
    ]
  },
  {
    path: '/validateSignup',
    component: () => import('@/views/signup/validateSignup'),
    hidden: true
  },
  {
    path: '/validateSignup/:hash/:email',
    component: () => import('@/views/signup/validateSignup'),
    hidden: true
  },
  {
    path: '/admin/user/edit:userId',
    component: () => import('@/views/admin/user/edit'),
    hidden: true
  },
  {
    path: '/changePassword',
    component: Layout,
    redirect: 'changePassword',
    children: [
      {
        path: '/changePassword',
        component: () => import('@/views/admin/user/changePassword'),
        name: 'changePassword',
        meta: { title: 'Change Password', icon: 'dashboard', noCache: true }
      }
    ],
    hidden: true
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/views/signup/index'),
    meta: { title: 'Signup', noCache: true },
    hidden: true
  }
]

export const asyncRouterMap = [
  {
    path: '/serviceMonitor',
    component: Layout,
    breadcrumb: true,
    redirect: '/serviceMonitor/index',
    meta: { title: 'Monitoring', icon: 'chart', noCache: true, role: 'serviceMonitor' },
    children: [
      {
        path: 'iriskMonitor',
        name: 'iriskMonitor',
        component: () => import('@/views/serviceMonitor/iriskMonitor/index'),
        meta: { title: 'I-Risk monitor', icon: 'chart', noCache: true, role: 'iriskMonitor' }
      },
      {
        path: 'nettingMarkup/index',
        component: () => import('@/views/serviceMonitor/nettingMarkup/index'),
        name: 'nettingMarkup',
        meta: { title: 'Netting Markup', icon: 'clipboard', noCache: true, role: 'nettingMarkup' }
      }
    ]
  },
  // {
  //   path: '/messages',
  //   component: Layout,
  //   redirect: 'messages',
  //   alwaysShow: false,
  //   children: [
  //     {
  //       path: 'messages',
  //       component: () => import('@/views/messages/index'),
  //       name: 'messages',
  //       meta: { title: 'Messages', icon: 'message', noCache: true, role: 'messages' }
  //     }
  //   ]
  // },
  {
    path: '/notifications',
    component: Layout,
    redirect: 'notifications',
    alwaysShow: false,
    children: [
      {
        path: 'notifications',
        component: () => import('@/views/notifications/index'),
        name: 'notifications',
        meta: { title: 'Notification Config', icon: 'message', noCache: true, role: 'messages' }
      }
    ]
  },
  {
    path: '/profile',
    userProfile: true,
    component: Layout,
    redirect: '/profile/edit',
    hidden: true,
    meta: { title: 'Admin', icon: 'lock', noCache: true },
    children: [
      {
        path: 'edit',
        name: 'profileEdit',
        component: () => import('@/views/admin/user/edit'),
        hidden: true,
        meta: { title: 'View', noCache: true }
      }
    ]
  },
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/index',
    meta: { title: 'Admin', icon: 'lock', noCache: true, role: 'admin' },
    children: [
      {
        path: 'user',
        component: () => import('@/views/admin/user/index'),
        redirect: '/admin/user/list',
        name: 'adminUser',
        meta: { title: 'User', icon: 'user', noCache: true, role: 'adminUser' },
        children: [
          {
            path: 'list',
            name: 'adminUserList',
            component: () => import('@/views/admin/user/list'),
            hidden: true,
            meta: { title: 'User List', noCache: true, activeMenu: '/admin/user' }
          },
          {
            path: 'edit',
            name: 'adminUserEdit',
            component: () => import('@/views/admin/user/edit'),
            hidden: true,
            meta: { title: 'View', noCache: true, activeMenu: '/admin/user', parent: 'adminUser' }
          }
        ]
      },
      {
        path: 'role',
        component: () => import('@/views/admin/role/index'),
        redirect: '/admin/role/list',
        name: 'adminRole',
        meta: { title: 'Role', icon: 'example', noCache: true, role: 'adminRole' },
        children: [
          {
            path: 'list',
            name: 'adminRoleList',
            component: () => import('@/views/admin/role/list'),
            hidden: true,
            meta: { title: 'Role List', noCache: true, activeMenu: '/admin/role' }
          },
          {
            path: 'edit',
            name: 'adminRoleEdit',
            component: () => import('@/views/admin/role/edit'),
            hidden: true,
            meta: { title: 'View', noCache: true, activeMenu: '/admin/role', parent: 'adminRole' }
          }
        ]
      },
      {
        path: 'broker',
        component: () => import('@/views/admin/broker/index'),
        redirect: '/admin/broker/list',
        name: 'adminBroker',
        meta: { title: 'Broker', icon: 'money', noCache: true, role: 'adminBroker' },
        children: [
          {
            path: 'list',
            name: 'adminBrokerList',
            component: () => import('@/views/admin/broker/list'),
            hidden: true,
            meta: { title: 'Broker List', noCache: true, activeMenu: '/admin/broker' }
          },
          {
            path: 'edit',
            name: 'adminBrokerEdit',
            component: () => import('@/views/admin/broker/edit'),
            hidden: true,
            meta: { title: 'View', noCache: true, activeMenu: '/admin/broker', parent: 'adminBroker' }
          }
        ]
      },
      {
        path: 'session',
        component: () => import('@/views/admin/session/index'),
        name: 'adminSession',
        redirect: '/admin/session/session',
        meta: { title: 'Sessions', icon: 'view_day', iconType: 'material', noCache: true, role: 'adminSession' },
        children: [
          {
            path: 'session',
            component: () => import('@/views/admin/session/index'),
            name: 'session',
            hidden: true,
            meta: { title: 'Sessions', noCache: true, activeMenu: '/admin/session' }
          }
        ]
      },
      {
        path: 'setting',
        component: () => import('@/views/admin/setting/index'),
        name: 'adminSetting',
        redirect: '/admin/setting/setting',
        meta: { title: 'Settings', icon: 'build', iconType: 'material', noCache: true, role: 'adminSetting' },
        children: [
          {
            path: 'setting',
            component: () => import('@/views/admin/setting/index'),
            name: 'setting',
            hidden: true,
            meta: { title: 'Settings', noCache: true, activeMenu: '/admin/setting' }
          }
        ]
      },
      {
        path: 'report',
        component: () => import('@/views/admin/report/index'),
        name: 'adminReport',
        redirect: '/admin/report/report',
        meta: { title: 'Reports', icon: 'assignment', iconType: 'material', noCache: true, role: 'adminReport' },
        children: [
          {
            path: 'report',
            component: () => import('@/views/admin/report/index'),
            name: 'report',
            hidden: true,
            meta: { title: 'Reports', noCache: true, activeMenu: '/admin/report' }
          }
        ]
      },
      {
        path: 'customView',
        component: () => import('@/views/admin/customView/index'),
        name: 'customView',
        redirect: '/admin/customView/customView',
        meta: { title: 'Custom View', icon: 'play_arrow', iconType: 'material', noCache: true, role: 'customView' },
        children: [
          {
            path: 'customView',
            component: () => import('@/views/admin/customView/index'),
            name: 'customView',
            hidden: true,
            meta: { title: 'Custom View', noCache: true, activeMenu: '/admin/customView' }
          }
        ]
      },
    ],
  },



  // customRouter,
  // { path: '/', redirect: '/home', hidden: true }
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
